import { forwardRef } from 'react';
import { Badge as MuiBadge, type BadgeProps } from '@mui/material';

const Badge = forwardRef<HTMLSpanElement, BadgeProps>((props, ref) => {
  return <MuiBadge ref={ref} {...props} />;
});

Badge.displayName = 'Badge';
export default Badge;
